import {
  IGetStartedWizardState,
  IQuery,
  StateFilterOption
} from '../../generated/graphql';
import { DEFAULT_TICKET_LIST_SORT_BY } from '../constants/ticketListConstants';

export const defaultClientState: IQuery = {
  ticketListState: {
    __typename: 'TicketListState',
    searchTerm: '',
    sortBy: DEFAULT_TICKET_LIST_SORT_BY,
    filter: {
      __typename: 'FilterOption',
      stateFilterOption: [StateFilterOption.New, StateFilterOption.Active],
      ageFilterOption: [],
      assignmentFilterOption: [],
      followFilterOption: []
    }
  },
  ticketListSelectionState: {
    __typename: 'TicketListSelectionState',
    selectedTicketIdsList: []
  },
  userSettings: {
    __typename: 'UserSettings',
    hideFirstRunExperience: true
  },
  sendAsState: {
    __typename: 'SendAsState',
    timeSet: null
  }
};
export const defaultGetStartedWizardState = {
  getGetStartedWizardState: {
    __typename: 'GetStartedWizardState',
    isActive: false,
    draftModalityType: '',
    draftEmailModality: {
      __typename: 'EmailModality',
      name: '',
      alias: '',
      aliasWithoutPrefixAndSuffix: '',
      autoReplyText: '',
      notifyUsers: [],
      notifyAllUsers: false,
      domain: ''
    },
    emailSetupMethod: '',
    isFinished: false,
    step: -1,
    ringId: '',
    configuredEmails: [],
    configuredNotifications: []
  } as IGetStartedWizardState
};
